module.exports = __webpack_public_path__ + "static/media/create_your_business_profile.f4b9b5d1.svg";